import { useCallback } from 'react'
import { authToken } from '../helpers/token'
import { remoteLogout } from '@wellesley/host-remote/api/actions'
import { Dispatch } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { localStorage } from 'helpers/localStorage'

export const logout = (dispatch: Dispatch) => {
  authToken.removeToken()
  dispatch(remoteLogout())
  localStorage('user').clear()
}

export const useLogout = () => {
  const dispatch = useDispatch()
  const handleLogout = useCallback(() => logout(dispatch), [dispatch])

  return { logout: handleLogout }
}
